import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import CountUp from 'react-countup';
import * as Yup from 'yup';
import Select from 'react-select';
import { CuentasCobrarModel } from '../../models/CuentasCobrarModel';
import {
  useEditarOrdenCobro,
  useGetDocumentsByCuentasCobrarId,
  useGetNoteByOrdenCobroId,
  useGetUsersCob,
  useObtenerOrdenPorID,
} from '../../hooks/CuentasCobrarHook';
import { useSelectGeneric } from '../../../../catalogos/generico/hooks/genericoHook';
import { encryptId, KTSVG } from '../../../../../../_metronic/helpers';
import { NoteList } from './sections/NoteList';
import { CreateNoteModal } from './_modals/CreateNoteModal';
import { DetailNoteModal } from './_modals/DetailNoteModal';
import { DocumentsList } from './sections/DocumentsList';

type Props = {
  cuentaCobrarId: number;
  onRefreshHistory: () => void;
};

const CuentasCobrarForm: React.FC<Props> = ({
  cuentaCobrarId,
  onRefreshHistory,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const { catalog: estatus } = useSelectGeneric('STS_ORD_COB');
  const { ordenCobro } = useObtenerOrdenPorID(Number(cuentaCobrarId));
  const { editarOrdenCobro } = useEditarOrdenCobro();

  const { dataSelect: usuarios } = useGetUsersCob();

  const validacion = Yup.object().shape({
    estatus: Yup.object({
      id: Yup.number()
        .required('El campo estatus es obligatorio')
        .min(1, 'Debe seleccionar un estatus válido'),
    }),
    cobrador: Yup.object({
      id: Yup.number()
        .required('El campo cobrador es obligatorio')
        .min(1, 'Debe seleccionar un cobrador válido'),
    }),
  });

  // SECCION NOTAS
  const sectionTabs = useRef<HTMLDivElement>(null);
  const [tabs, setTabs] = useState<string | 'NOTE' | 'DOC'>('NOTE');
  const [activeNewNote, setActiveNewNote] = useState<boolean>(false);
  const [showNoteModal, setShowNoteModal] = useState<boolean>(false);
  const [showNoteDetailModal, setShowNoteDetailModal] =
    useState<boolean>(false);
  // NOTAS
  const [reloadGridNotes, setReloadGridNotes] = useState<number>(
    Math.random() * 40
  );
  const { notes, loadingNote } = useGetNoteByOrdenCobroId(
    cuentaCobrarId,
    reloadGridNotes
  );

  // DOCUMENTS
  const [reloadDocuments, setReloadDocuments] = useState(Math.random() * 40);
  const { dataDocuments, loadingDocuments } = useGetDocumentsByCuentasCobrarId(
    cuentaCobrarId,
    reloadDocuments
  );

  const Formulario = useFormik<CuentasCobrarModel>({
    initialValues: ordenCobro,
    validationSchema: validacion,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true);
      await editarOrdenCobro(values);
      setLoading(false);
    },
  });

  const addDaysToDate = (date: string, days: number) => {
    if (!date) return '';
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    const formattedDate = newDate.toISOString().split('T')[0];
    return formattedDate;
  };

  const userSelected = (selectedOption: any) => {
    const { value } = selectedOption;
    Formulario.setFieldValue('cobrador.id', value);
  };

  // SECTIONS NOTES
  const openModal = (isOpen: boolean) => {
    setShowNoteModal(isOpen);
  };
  const openDetailModal = (isOpen: boolean) => {
    setShowNoteDetailModal(isOpen);
  };

  return (
    <>
      <form
        id="kt_account_form"
        className="form"
        action="#"
        noValidate
        onSubmit={Formulario.handleSubmit}
      >
        <div className="card mb-6 mb-xl-9">
          <div className="card-body">
            <div className="row">
              <div className="col-12 p-0">
                <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                  <div className="flex-grow-1">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8 p-0">
                        <div className="w-100">
                          <input
                            className="form-control border-0 ms-6"
                            style={{
                              width: '99%',
                              padding: '15px',
                              fontSize: '24px',
                              boxSizing: 'border-box',
                            }}
                            maxLength={40}
                            disabled={true}
                            data-kt-element="input"
                            placeholder="Nombre *"
                            {...Formulario.getFieldProps('nombre')}
                          ></input>
                          {Formulario.touched.nombre &&
                            Formulario.errors.nombre && (
                              <div className="fv-plugins-message-container text-danger ms-5 w-100 mb-3">
                                <span role="alert">
                                  {Formulario.errors.nombre}
                                </span>
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 p-3">
                        <div className="w-100 ms-10">
                          <div className="w-100 d-flex">
                            <label className="form-label w-auto">
                              Id de la cotización
                            </label>
                          </div>
                          <div
                            className={`mt-2 badge badge-light-primary fs-6`}
                          >
                            {Formulario.values.cotizacion.folio}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-2">
                    <div className="d-flex mb-4 justify-content-end me-8">
                      <div className="d-flex justify-content-end flex-shrink-0">
                        <a
                          href="#/"
                          data-kt-menu="true"
                          className="btn btn-sm btn-icon btn-light-primary "
                          data-kt-menu-trigger="hover"
                          data-kt-menu-placement="bottom-end"
                        >
                          <KTSVG
                            path="/media/icons/duotune/general/gen052.svg"
                            className="svg-icon-5 svg-icon-gray-500"
                          />
                        </a>
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4"
                          data-kt-menu="true"
                        >
                          <div className="menu-item px-3">
                            <div
                              className="menu-link px-3"
                              style={{ color: '#616467' }}
                              onClick={() => {
                                if (Formulario.values.cotizacion.id) {
                                  const { id } = Formulario.values.cotizacion;
                                  history.push(
                                    `/cotizaciones/preview/pdf/${encryptId(
                                      id.toString()
                                    )}`
                                  );
                                }
                              }}
                            >
                              <KTSVG
                                path="/media/icons/duotune/general/pdf-ic.svg"
                                className="svg-icon-5 svg-icon-gray-500 mr-05"
                              />
                              Generar PDF Cotización
                            </div>
                          </div>
                          <div className="menu-item px-3">
                            <div
                              className="menu-link px-3"
                              style={{ color: '#616467' }}
                              onClick={() => {
                                if (cuentaCobrarId) {
                                  history.push(
                                    `/cobranza/cuentas_cobrar/preview/pdf/${encryptId(
                                      cuentaCobrarId.toString()
                                    )}`
                                  );
                                }
                              }}
                            >
                              <KTSVG
                                path="/media/icons/duotune/general/pdf-ic.svg"
                                className="svg-icon-5 svg-icon-gray-500 mr-05"
                              />
                              Generar PDF Orden de cobro
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">
                      Tipo de proyecto
                    </label>
                  </div>
                  <div className={`  mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={Formulario.values.tipoProyecto.name}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">
                      Unidad de moneda
                    </label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={Formulario.values.unidadMoneda.name}
                    ></input>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">Cuenta</label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={Formulario.values.cuenta.nombre}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto">Subcuenta</label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={
                        Formulario.values.subcuenta &&
                        Formulario.values.subcuenta.nombre
                      }
                    ></input>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 d-flex flex-column ">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">
                      Vendedor Asignado
                    </label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={`${Formulario.values.vendedorAsignado.nombre} ${Formulario.values.vendedorAsignado.apellido_paterno} `}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto">Contacto</label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={`${Formulario.values.contacto.nombre} ${Formulario.values.contacto.apellido_paterno}`}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto">Teléfono</label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={Formulario.values.telefono}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <label className="required form-label w-auto">
                  Cobrador asignado:
                </label>
                <Select
                  options={usuarios}
                  value={
                    Formulario.values.cobrador
                      ? usuarios.find(
                          (option) =>
                            option.id === Formulario.values.cobrador.id
                        )
                      : null
                  }
                  styles={{
                    placeholder: (provided: any, state: any) => ({
                      ...provided,
                      color: '#181c32',
                      textAlign: 'center',
                    }),
                    indicatorSeparator: (provided: any, state: any) => ({
                      ...provided,
                      display: 'none',
                    }),
                    dropdownIndicator: (provided: any, state: any) => ({
                      ...provided,
                      color: '#9096EC',
                      display: 'none',
                    }),
                    control: (provided: any, state: any) => ({
                      ...provided,
                      border: 'none',
                      borderRadius: '6px',
                      marginBottom: '3px',
                      padding: '3px',
                      fontSize: '1rem',
                      boxShadow: 'none',
                      backgroundColor: state.isDisabled ? '#EFF2F5' : 'white',
                    }),
                    singleValue: (provided: any, state: any) => ({
                      ...provided,
                      color: state.isDisabled ? '#181c32' : 'inherit',
                      fontWeight: 500,
                    }),
                    option: (provided: any, state: any) => ({
                      ...provided,
                      fontSize: '1.0rem',
                      textAlign: 'center',
                    }),
                  }}
                  formatOptionLabel={(option) => (
                    <div
                      className="d-flex"
                      style={{ alignItems: 'center', width: '100%' }}
                    >
                      {option.data && option.data.profile_photo ? (
                        <>
                          <div className="symbol symbol-30px">
                            <img
                              src={`${process.env.REACT_APP_PUBLIC}users/${option.data.profile_photo}`}
                              title={`${option.data.first_name} ${option.data.father_last_name} ${option.data?.mother_last_name}`}
                              crossOrigin="anonymous"
                              className="symbol-label fs-5 "
                              alt="user"
                            />
                          </div>
                          <span className="ms-3 ">
                            {option.data.first_name}{' '}
                            {option.data.father_last_name}{' '}
                            {option.data?.mother_last_name}
                          </span>
                        </>
                      ) : (
                        <>
                          <div className="symbol symbol-30px">
                            <span className="symbol-label fs-7 fw-bold bg-light-primary text-primary fw-bold">
                              {option.data.first_name &&
                                option?.data.first_name[0]}
                              {option.data.father_last_name &&
                                option?.data.father_last_name[0]}
                            </span>
                          </div>
                          <span className="ms-3 ">
                            {option.data.first_name}{' '}
                            {option.data.father_last_name}{' '}
                            {option.data?.mother_last_name}
                          </span>
                        </>
                      )}
                    </div>
                  )}
                  placeholder={
                    <span className="symbol symbol-30px cursor-pointer">
                      <div className="symbol-label">
                        <KTSVG
                          path="/media/icons/duotune/communication/com006.svg"
                          className="svg-icon-1"
                        />
                      </div>
                    </span>
                  }
                  isSearchable={true}
                  noOptionsMessage={() => {
                    return <span>{'No se encontraron registros'}</span>;
                  }}
                  onChange={(event) => userSelected(event)}
                />
                {Formulario.touched.cobrador?.id &&
                  Formulario.errors.cobrador?.id && (
                    <div className="fv-plugins-message-container text-danger w-100 mt-3 mb-3">
                      <span role="alert">{Formulario.errors.cobrador.id}</span>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className="card mb-6 mb-xl-9">
          <div className="card-header">
            <div className="card-title m-0">
              <h3 className="fw-bolder m-0">Datos del cobro</h3>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">
                      Concepto de cobro
                    </label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={Formulario.values.concepto_cobro}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">Cobro no.</label>
                  </div>
                  <div className={`mt-2 badge badge-light-success fs-6`}>
                    {Formulario.values.no_cobro}
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="d-flex justify-content-center w-100">
                  <div
                    className="w-100 border border-gray-300 rounded d-flex justify-content-center align-items-center"
                    style={{ height: '65px' }}
                  >
                    <div className="text-center">
                      <span
                        className="fs-2x fw-bold"
                        style={{ color: '#1B84FF' }}
                      >
                        <h6 className="mt-2 fs-7 text-gray-700"> Cobro</h6>
                        <CountUp
                          end={Number(Formulario.values.cobro)}
                          duration={1}
                          prefix="$"
                          decimals={2}
                          className="fs-1"
                        />
                      </span>

                      <span className="fs-7 fw-semibold opacity-50">
                        {Formulario.values.unidadMoneda && (
                          <>
                            /{' '}
                            <span data-kt-element="period">
                              {Formulario.values.unidadMoneda.code}
                            </span>
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">
                      Fecha de solicitud
                    </label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      className={'form-control'}
                      disabled={true}
                      data-kt-element="input"
                      type="date"
                      name="fecha_inicio"
                      value={Formulario.values.created_at}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">Etapa</label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={
                        Formulario.values.etapa && Formulario.values.etapa.name
                      }
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">Tipo de pago</label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={
                        Formulario.values.tipoPago &&
                        Formulario.values.tipoPago.name
                      }
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">Folio factura</label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      type="text"
                      className="form-control"
                      maxLength={20}
                      {...Formulario.getFieldProps('folio')}
                      // value={Formulario.values.folio}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">
                      Fecha de facturación
                    </label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      className={'form-control'}
                      data-kt-element="input"
                      type="date"
                      name="fecha_inicio"
                      value={Formulario.values.fecha_facturacion || ''}
                      onChange={(e) => {
                        let dias_vencimiento = Formulario.values.formaPago
                          ? Formulario.values.formaPago.dias_pago
                          : 0;
                        Formulario.setFieldValue(
                          'fecha_facturacion',
                          e.target.value
                        );
                        Formulario.setFieldValue(
                          'fecha_vencimiento',
                          addDaysToDate(e.target.value, dias_vencimiento)
                        );
                      }}
                    />
                    {Formulario.touched.fecha_facturacion &&
                      Formulario.errors.fecha_facturacion && (
                        <div className="fv-plugins-message-container text-danger w-100 mb-3">
                          <span role="alert">
                            {Formulario.errors.fecha_facturacion}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">
                      Fecha de vencimiento
                    </label>
                  </div>
                  <div className={`mb-5`}>
                    <input
                      className={'form-control'}
                      disabled={true}
                      data-kt-element="input"
                      type="date"
                      name="fecha_inicio"
                      value={Formulario.values.fecha_vencimiento || ''}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                <div className="w-100 pe-5">
                  <div className="w-100 d-flex">
                    <label className=" form-label w-auto">Estatus</label>
                  </div>
                  <select
                    className="form-select mb-3"
                    data-kt-select2="true"
                    data-placeholder="Select option"
                    data-allow-clear="true"
                    {...Formulario.getFieldProps('estatus.id')}
                  >
                    <option value={0}>Seleccione</option>
                    {estatus.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {Formulario.touched.estatus?.id &&
                    Formulario.errors.estatus?.id && (
                      <div className="fv-plugins-message-container text-danger w-100 mb-3">
                        <span role="alert">{Formulario.errors.estatus.id}</span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card mb-6 mb-xl-9">
          <div className="card-body">
            <div className="row">
              <div className="d-flex justify-content-end mt-10">
                <button
                  type="reset"
                  className="btn btn-light me-3"
                  data-kt-users-modal-action="cancel"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  Cancelar
                </button>

                {Formulario.values.etapa &&
                  Formulario.values.etapa.code !== 'PAG' && (
                    <>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        data-kt-users-modal-action="submit"
                        disabled={loading}
                      >
                        {!loading && (
                          <span className="indicator-label">Guardar</span>
                        )}
                        {loading && (
                          <span
                            className="indicator-progress"
                            style={{ display: 'block' }}
                          >
                            Espere por favor...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </form>
      <div className="row g-6 g-xl-9" ref={sectionTabs}>
        <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
          <div className="card card-flush p-5">
            <div className="row mb-5">
              <div className="col-xxl-8 col-xl-8 col-md-8 col-lg-8">
                <ul className="nav nav-line-tabs nav-line-tabs-2x border-transparent fs-7 fw-bolder flex-nowrap">
                  <li className="nav-item cursor-pointer ">
                    <div
                      className={`nav-link me-6 ${
                        tabs === 'NOTE' ? 'text-active-primary active' : ''
                      } `}
                      onClick={() => {
                        setTabs('NOTE');
                      }}
                    >
                      <span className="margin-left-05">Notas</span>
                    </div>
                  </li>
                  <li className="nav-item cursor-pointer ">
                    <div
                      className={`nav-link me-6 ${
                        tabs === 'DOC' ? 'text-active-primary active' : ''
                      } `}
                      onClick={() => {
                        setTabs('DOC');
                      }}
                    >
                      <span className="margin-left-05">Documentos</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              {tabs === 'NOTE' ? (
                <>
                  <NoteList
                    data={notes}
                    onOpenModal={openModal}
                    active={activeNewNote}
                    onOpenDetailModal={openDetailModal}
                  ></NoteList>
                </>
              ) : null}
              {tabs === 'DOC' ? (
                <>
                  <DocumentsList
                    documents={dataDocuments}
                    onRefreshData={() => {
                      setReloadDocuments(Math.random() * 100);
                      onRefreshHistory();
                    }}
                    id={cuentaCobrarId}
                    isEdit={false}
                  ></DocumentsList>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <CreateNoteModal
        show={showNoteModal}
        handleClose={(refresh) => {
          setShowNoteModal(!showNoteModal);
          if (refresh) {
            setReloadGridNotes(Math.random() * 40);
            onRefreshHistory();
          }
        }}
        cuenta_cobrar_id={cuentaCobrarId}
      ></CreateNoteModal>
      <DetailNoteModal
        show={showNoteDetailModal}
        handleClose={(refresh) => {
          setShowNoteDetailModal(!showNoteDetailModal);
          onRefreshHistory();
        }}
        data={notes}
        id={cuentaCobrarId}
      ></DetailNoteModal>
    </>
  );
};

export { CuentasCobrarForm };
